import React, { FC } from 'react'

import { FormattedMessage } from 'react-intl'

import { fontSize13Number } from 'components/layout/MambaLayout/variantsIndent'
import { PlainTitle } from 'components/presentational/title/PlainTitle'

export const PresentVipTitleHidden: FC = () => {
  return (
    <PlainTitle fontSize={fontSize13Number} boldText={true}>
      <FormattedMessage id="stream.gift.anonymously" />
    </PlainTitle>
  )
}
